import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { GetBannerDetailsRequest } from '../api/banner/getbannerdetails/getbannerdetailsrequest';
import { GetBannerDetailsResponse, GetBannerDetailsResponseDtoImpl } from '../api/banner/getbannerdetails/getbannerdetailsresponse';
import { GetBannerBuilder } from '../dto/getbannerdetails/getbannerbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { GetBannerToneDto } from '../dto/getbannerdetails/getbannertonedto';

export class GetBannerDetailsAPIProcessorImpl extends APIProcessorImpl<GetBannerDetailsRequest, GetBannerDetailsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(GetBannerDetailsAPIProcessorImpl.name);
    execute(request: GetBannerDetailsRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetBannerDetailsResponseDtoImpl(APIFeatures.GET_BANNER_DETAILS, "Get Banner Details Success");
                let getBannerDetailsResponse:GetBannerToneDto[] = new GetBannerBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll();

                response.setGetBannerDto(getBannerDetailsResponse);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetBannerDetailsResponseDtoImpl(APIFeatures.GET_BANNER_DETAILS, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetBannerDetailsResponseDtoImpl(APIFeatures.GET_BANNER_DETAILS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            console.log(e);
            this.getAPIFailure(new GetBannerDetailsResponseDtoImpl(APIFeatures.GET_BANNER_DETAILS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
     
     this.getAPIFailure(new GetBannerDetailsResponseDtoImpl(APIFeatures.GET_BANNER_DETAILS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getbannerdetailsapiprocessor.tsx